import { gql } from '@apollo/client';

export const FETCH_CLIENT_GROUP_NAME = gql`
  query fetchClientGroupName($id: SafeString!) {
    fetchClientGroup(input: { clientGroupId: $id }) {
      clientGroup {
        id: stringId
        name
      }
    }
  }
`;
